import { MAPURL } from "config/info";
import useSetting from "hooks/useSetting";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import parse from "html-react-parser";
import { miladiToJalali } from "utils/dateTools";
import { useRouter } from "next/router";
import { LiaInstagram } from "react-icons/lia";
import { LiaTelegramPlane } from "react-icons/lia";
import { LiaWhatsapp } from "react-icons/lia";

const Footer = ({ isCRDC }: { isCRDC: boolean }) => {
  const { data } = useSetting(isCRDC);
  const { t } = useTranslation("common");
  const { locale } = useRouter();

  const QuickAccessItems = [
    { name: t("MainPage"), path: isCRDC ? "/research" : "/" },
    {
      name: t("AboutUs"),
      path: isCRDC ? "/research/unit-introduction" : "/why-us/introduction",
    },
    {
      name: t("ContactUs"),
      path: isCRDC ? "/research/contact-us" : "/visitors-guide/contact-us",
    },
    { name: t("DepartmentsOfValiasrHospital"), path: "/visitors-guide/sections" },
  ];

  const ElectronicItems = isCRDC
    ? [
        {
          name: t("Medscape"),
          path: "https://www.medscape.com/?src=ppc_google_acq_solo&gclid=CjwKCAiAxvGfBhB-EiwAMPakqiubifmlYGnceZLh4FHkCA-QOrJvUGLN-Vy_zlLSx5NfsK6xY8KQSRoCh7sQAvD_BwE",
        },
        { name: t("Cochrane"), path: "https://cochranelibrary.com" },
        {
          name: t("CochraneIran"),
          path: "https://iran.cochrane.org/fa",
        },
        { name: t("ScientificInformationDatabase"), path: "https://www.nih.gov" },
      ]
    : [
        { name: t("TukaSystem"), path: "http://2.186.229.12:2406/tooka" },
        {
          name: t("CorporateEmail"),
          path: "http://tabrizhospital.ir/roundcube/?_task=mail&_mbox=INBOX",
        },
        {
          name: t("onlineReservation"),
          path: "https://vht-app.ir",
        },

        { name: t("Automation"), path: "http://2.186.229.12:5000/" },
        { name: t("DownloadRadiologyImagesOnline"), path: "http://2.186.229.12:8088" },
      ];

  return (
    <footer className="mt-[14rem] flex justify-center bg-[#00255B]">
      <div className="container relative">
        <section className="relative  mx-auto !mt-[-10rem] flex h-[294px] flex-col items-center justify-center rounded-[15px] bg-white  px-16  md:w-full md:px-0">
          <iframe
            src={MAPURL}
            width="100%"
            allowFullScreen={false}
            loading="lazy"
            className="absolute left-0 top-0 h-full w-full rounded-15"
            referrerPolicy="no-referrer-when-downgrade"
          />

          <div className="absolute bottom-0 left-0 grid h-[120px] w-full grid-cols-1 rounded-b-15 bg-primary-main md:h-[80px] md:grid-cols-3">
            <p className="m-auto flex h-[68%] w-full items-center justify-center border-l-[#ffffff70] text-center text-14 font-medium text-white md:border-l-2 md:text-16">
              <i className="icon-makan me-16 text-[28px] text-white" />
              {data?.address}
            </p>
            <p className="m-auto flex h-[68%] w-full items-center justify-center border-l-[#ffffff70] text-center text-14 font-medium text-white md:border-l-2 md:text-16">
              <i className="icon-telephon me-16 text-[28px] text-white" />
              {data?.phone1} - {data?.phone2}
            </p>
            <p className="m-auto flex h-[68%] w-full items-center justify-center border-l-[#ffffff70] text-center text-14 font-medium text-white md:border-l-2 md:text-16">
              <i className="icon-mail me-16 text-[24px] text-white" />
              {data?.email}
            </p>
          </div>
        </section>

        <div className="grid grid-cols-1 gap-24 pb-24 pt-[3rem] md:grid-cols-4 md:gap-[100px] md:pt-[4rem]">
          <div>
            <Image
              src={isCRDC ? "/assets/logo-tahgig.png" : "/assets/logo.png"}
              width="160"
              height={"30"}
              alt="لوگو بیمارستان ولیعصر"
            />
            <div className="line-5 mt-22 max-w-[460px]  text-justify text-16 text-white">
              {!!data?.footer && parse(data?.footer)}
            </div>
            <div className="mt-8 flex gap-48">
              <Link href="https://t.me/tabriz_hospital" target="_blank">
                <LiaTelegramPlane color="#fff" size={30} />
              </Link>
              <Link
                href="https://www.instagram.com/tabriz_hospital?igsh=MW55Z3R0Z3liNHZ0YQ=="
                target="_blank"
              >
                <LiaInstagram color="#fff" size={30} />
              </Link>
              <Link href="https://chat.whatsapp.com/Dua4nAAT3gPCvrDfVUa8X9" target="_blank">
                <LiaWhatsapp color="#fff" size={30} />
              </Link>
            </div>
          </div>

          <div>
            <h2 className="  before:content-['' relative me-50 text-18 font-semibold text-white before:absolute before:bottom-[-8px] before:h-4 before:w-[31px] before:rounded-8 before:bg-primary-main before:duration-500 before:ease-in-out">
              {t("Shortcut")}
            </h2>
            {QuickAccessItems.map((el, i) => {
              return (
                <Link href={el.path} passHref key={i} prefetch={false}>
                  <p
                    style={i === 0 ? { marginTop: "2rem" } : {}}
                    className=" mt-22 w-max text-white duration-500 
                  ease-in-out after:block after:scale-x-0 after:transform after:border-b-2
                  after:border-solid after:border-b-primary-main after:pt-4 after:duration-500 after:ease-in-out after:content-[''] hover:ps-12 hover:after:scale-x-100"
                  >
                    {el.name}
                  </p>
                </Link>
              );
            })}
          </div>
          <div>
            <h2 className="  before:content-['' relative me-50 text-18 font-semibold text-white before:absolute before:bottom-[-8px] before:h-4 before:w-[31px] before:rounded-8 before:bg-primary-main before:duration-500 before:ease-in-out">
              {isCRDC ? t("UsefulLinks") : t("ElectronicServices")}
            </h2>
            {ElectronicItems.map((el, i) => {
              return (
                <Link
                  href={el.path}
                  passHref
                  key={i}
                  prefetch={false}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <p
                    style={i === 0 ? { marginTop: "2rem" } : {}}
                    className=" mt-22 w-max text-white duration-500 
                  ease-in-out after:block after:scale-x-0 after:transform after:border-b-2
                  after:border-solid after:border-b-primary-main after:pt-4 after:duration-500 after:ease-in-out after:content-[''] hover:ps-12 hover:after:scale-x-100"
                  >
                    {el.name}
                  </p>
                </Link>
              );
            })}
          </div>
          <div>
            <h2 className="relative me-50 text-18 font-semibold text-white before:absolute before:bottom-[-8px] before:h-4 before:w-[31px] before:rounded-8 before:bg-primary-main  before:duration-500 before:ease-in-out  before:content-['']">
              {t("Permissions")}
            </h2>
            <Link
              rel="nofollow"
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=527346&Code=5pYs6OWvpPmfzJVavNiLHPBBnoLDnhTt">
               <div className="mt-22 bg-white p-2 rounded w-[130px]">
               <Image
                  src="/assets/enamad.png"
                  alt="enamad"
                  width={120}
                  height={200}
                />
               </div>
             </Link>
          </div>
        </div>

        <div className="flex items-center justify-between pb-12">
          <div className="flex items-center gap-x-4">
            <p className="pe-8 text-12 text-white">{t("PoweredBy")}</p>

            <p className="text-12 text-orange-400">{`(آخرین تاریخ بروزرسانی : ‌${miladiToJalali(
              new Date(),
              locale
            )})`}</p>
          </div>

          <Link
            prefetch={false}
            passHref
            href={"https://arkatech.ir/"}
            className="cursor-pointer"
            target={"_blank"}
          >
            <Image
              src="/assets/Arka-Logo-1x.webp"
              width={82}
              height={30}
              alt="لوگو شرکت بهین فناوران آرکا"
            />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
